var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics container"},[_vm._m(0),_c('div',{staticClass:"main"},[_c('div',{staticClass:"data"},[_c('div',{staticClass:"one",on:{"click":function($event){return _vm.$router.push({
            path: '/courseDetail/statistics/detail',
            query: {
              ..._vm.$route.query,
              type: 'video',
            },
          })}}},[_c('p',[_vm._v("视频统计")]),_c('el-progress',{attrs:{"stroke-width":30,"percentage":_vm.statisticsinfo.videoRate,"text-inside":true}})],1),_c('div',{staticClass:"one",on:{"click":function($event){return _vm.$router.push({
            path: '/courseDetail/statistics/detail',
            query: {
              ..._vm.$route.query,
              type: 'ppt',
            },
          })}}},[_c('p',[_vm._v("PPT统计")]),_c('el-progress',{attrs:{"stroke-width":30,"percentage":_vm.statisticsinfo.pptRate,"text-inside":true}})],1),_c('div',{staticClass:"one",on:{"click":function($event){return _vm.$router.push({
            path: '/courseDetail/statistics/detail',
            query: {
              ..._vm.$route.query,
              type: 'test',
            },
          })}}},[_c('p',[_vm._v("测评统计")]),_c('el-progress',{attrs:{"stroke-width":30,"percentage":_vm.statisticsinfo.testRate,"text-inside":true}})],1),_c('div',{staticClass:"one",on:{"click":function($event){return _vm.$router.push({
            path: '/courseDetail/statistics/detail',
            query: {
              ..._vm.$route.query,
              type: 'works',
            },
          })}}},[_c('p',[_vm._v("实战统计")]),_c('el-progress',{attrs:{"stroke-width":30,"percentage":_vm.statisticsinfo.szRate,"text-inside":true}})],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top_info"},[_c('div',{staticClass:"title"},[_vm._v("学情统计")])])
}]

export { render, staticRenderFns }